<template>
    <div class="wrapper" style="height: 100%!important">
        <div class="sa-card-list">
            <b-row>
                <b-col v-for="item of items" :key="item.id" class="sa-card-list-col" cols="12" xs="12" sm="12"
                    :md="sizeColumn" :lg="sizeColumn" :xl="sizeColumn">
                    <div class="sa-card-list-container">
                        <div class="sa-card-list-container-header">
                            <slot name="header" :item="item"></slot>
                        </div>
                        <div class="sa-card-list-container-body">
                            <div style="align-content: center; padding: 2px;">
                                <i v-if="logoIcon && logoIcon.includes('fas')"
                                    :class="['fa-3x', 'text-muted', logoIcon]"></i>
                                <img v-else-if="logoIcon && logoIcon.includes('assets')" :src="logoIcon" alt="logo" />
                                <slot name="left" :item="item"></slot>
                            </div>
                            <div style="flex: 1; padding-left: 5px; padding: 8px">
                                <div class="sa-card-list-container-body-row">
                                    <slot name="right" :item="item"></slot>
                                </div>
                            </div>
                        </div>
                        <div class="sa-card-list-container-footer text-right">
                            <slot name="actions" :item="item"></slot>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
    </div>
</template>

<script>
import UtilityMixin from '../../../app/utility/UtilityMixin';
export default {
    mixins: [UtilityMixin],
    data() {
        return {

        }
    },
    props: {
        items: {
            type: [Array, Object],
            required: true,
            default: () => { return {} }
        },
        logoIcon: {
            type: String,
            required: false,
            default: () => { return null }
        },
        sizeColumn: {
            type: Number,
            default: () => { return 4 }
        }
    },
    methods: {
        createLogoImage() {
            if (this.logoIcon) {
                if (this.logoIcon.includes("fas")) {
                    return `<i class="${this.logoIcon} fa-3x text-muted mb-3"></i>`;
                }
                if (this.logoIcon.includes("assets")) {
                    return `<img src="${this.logoIcon}"></img>`;
                }
            }

        }
    }
}
</script>

<style lang="scss" scoped></style>